<template>
    <div class="flex row-stretch">
        <div class="flex-1">
            <QTabs
                v-model="dashboardTab"
                align="left"
                dense
                noCaps
                inlineLabel
                activeColor="primary"
                indicatorColor="primary"
                class="DashboardTabs text-grey-8"
                @update:modelValue="handleChangeTab"
            >
                <QTab
                    v-for="opt in dashboardsList"
                    :key="opt.identifier"
                    :label="opt.name"
                    :name="opt.identifier"
                >
                    <QIcon
                        v-if="dashboardsList.length > 1"
                        name="close"
                        size="xs"
                        class="q-ml-sm"
                        @click.stop="handleOpenDeleteDashboardModal(opt)"
                    />
                </QTab>
                <QTab
                    icon="add"
                    name="new-dashboard"
                    @click="openCreateDashboardModal"
                >
                    <QTooltip>{{ $t('dashboards.addDashboard') }}</QTooltip>
                </QTab>
            </QTabs>

            <div
                :key="tabKey"
            >
                <div>
                    <GridGraphs
                        v-if="dashboard"
                        :key="dashboardTab"
                        ref="gridGraphs"
                        :processId="processId"
                        :dashboard="dashboard"
                        @updateDashboardContent="getDashboardsList"
                        @drawer-state-changed="handleDrawerStateChanged"
                    />
                </div>
            </div>
        </div>
        <DeleteModal
            ref="deleteDashboardModal"
            @onDelete="handleDeleteDashboard"
        />
        <ModalNameDesc
            ref="newDashboardModal"
            v-model="newDashboardModal"
            :title="$t('dashboards.addDashboard')"
            :action="$t('actions.create')"
            :loading="dashboardsLoading"
            withoutDesc
            @on-submit="createNewDashboard"
        />
        <q-inner-loading
            :showing="dashboardsLoading"
        />
    </div>
</template>

<script>
import {
    Api,
    apiRequest,
    notifyError,
} from '@/api'
import { ModalNameDesc } from '@/components'
import { GridGraphs, DeleteModal } from './components'

export default {
    name: 'DashboardsComponent',
    components: {
        DeleteModal,
        GridGraphs,
        ModalNameDesc,
    },
    emits: ['drawer-state-changed'],
    data() {
        return {
            processId: this.$route.params.processId || undefined,
            tabKey: 0,
            dashboard: undefined,
            dashboardTab: undefined,
            dashboardsList: [],
            dashboardsLoading: true,
            newDashboardName: "",
            newDashboardModal: false,
            dashboardToDelete: undefined,
        }
    },
    mounted() {
        this.getDashboardsList()
        // this.$eventBus.on('reloadTabKey', this.reloadTabKey)
    },
    methods: {
        handleDrawerStateChanged(payload) {
            this.$emit('drawer-state-changed', payload)
        },
        async getDashboardsList() {
            this.dashboardsLoading = true
            return apiRequest(Api().datasets.getDashboardList({ datasetId: this.processId }))
                .then(({ dashboards }) => {
                    this.dashboardsList = dashboards
                    if (this.dashboardsList.length > 0) {
                        // eslint-disable-next-line prefer-destructuring
                        this.dashboard = this.dashboardTab === 'new-dashboard'
                            ? this.dashboardsList[this.dashboardsList - 1]
                            : this.dashboardsList.find((i) => i.identifier === this.dashboardTab) || this.dashboardsList[0]
                        this.dashboardTab = this.dashboard.identifier
                    }
                })
                // REVISAR -> SALTA ERRROR EN FRONT (By Maria)
                .catch(() => {})
                .finally(() => {
                    this.dashboardsLoading = false
                })
        },
        openCreateDashboardModal() {
            this.newDashboardModal = true
        },
        async createNewDashboard(dashboardParams) {
            this.newDashboardName = dashboardParams.name

            this.dashboardsLoading = true
            const params = { name: this.newDashboardName, size: [3, 2], content: [] }

            apiRequest(Api().datasets.createDashboard({ datasetId: this.processId, params }))
                .then(() => this.getDashboardsList())
                .then(() => {
                    const newDashboard = this.dashboardsList.find((dashboard) => dashboard.name === this.newDashboardName)
                    if (newDashboard) {
                        this.handleChangeTab(newDashboard.identifier)
                    }
                    this.newDashboardModal = false
                })
                .catch(notifyError)
                .finally(() => {
                    this.dashboardsLoading = false
                })
        },
        async deleteDashboard() {
            if (!this.dashboardToDelete) return
            this.dashboardsLoading = true
            apiRequest(Api().datasets.deleteDashboard({ datasetId: this.processId, dashboardId: this.dashboardToDelete.identifier }))
                .then(() => this.getDashboardsList())
                .catch(notifyError)
                .finally(() => {
                    this.dashboardToDelete = null
                    this.$refs.deleteDashboardModal.close()
                    this.dashboardsLoading = false
                })
        },
        handleChangeTab(dashboardIdentifier) {
            if (dashboardIdentifier === "new-dashboard") {
                this.newDashboardName = ""
                this.dashboard = null
            } else {
                this.dashboard = this.dashboardsList.find((dashboard) => dashboard.identifier === dashboardIdentifier)
            }
            this.dashboardTab = dashboardIdentifier
        },
        handleDeleteDashboard() {
            this.deleteDashboard()
        },
        handleOpenDeleteDashboardModal(dashboard) {
            this.dashboardToDelete = dashboard
            this.$refs.deleteDashboardModal.open(this.dashboardToDelete)
        },
        reloadTabKey() {
            this.tabKey += 1
        },

        enterEditMode() {
            this.$refs.gridGraphs?.enterEditMode?.()
        },
        saveEditMode() {
            this.$refs.gridGraphs?.saveEditMode?.()
        },
        cancelEditMode() {
            this.$refs.gridGraphs?.cancelEditMode?.()
        },
        setSideTab(tab) {
            this.$refs.gridGraphs?.setSideTab?.(tab)
        },
        addGraph({ type, group } = {}) {
            this.$refs.gridGraphs?.addGraphFromPanel?.({ type, group })
        },
        updateTriggers({ triggers } = {}) {
            this.$refs.gridGraphs?.updateTriggers?.(triggers)
        },
        updateGraph(payload) {
            this.$refs.gridGraphs?.updateGraph?.(payload)
        },
        renameGraph({ name } = {}) {
            this.$refs.gridGraphs?.renameCurrentGraph?.({ name })
        },
    },
}
</script>
<style scoped lang="scss">

.CreateDashboard {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.DashboardTabs {
    padding: 0 16px;

    :deep(.q-tab__label) {
        letter-spacing: 1.25px;
    }
}

</style>
